export default __webpack_public_path__ + "static/media/35.0524095e.jpg";